import { AudienceOverlapProviderResult } from "src/app/components/AudienceOverlap/types";
import {
  AudienceOverlapData,
  AudienceOverlapReportInfo,
  SOCIAL_LABELS,
} from "src/types";

export const getAOChartData = (reportInfo: AudienceOverlapReportInfo) => {
  if (!reportInfo) return [];

  return [
    {
      name: "front_audience_overlap_total_overlapping_followers",
      amount: reportInfo.totalFollowers - reportInfo.totalUniqueFollowers,
      percent:
        (reportInfo.totalFollowers - reportInfo.totalUniqueFollowers) /
        reportInfo.totalFollowers,
    },
    {
      name: "front_audience_overlap_total_unique_followers",
      amount: reportInfo.totalUniqueFollowers,
      percent: reportInfo.totalUniqueFollowers / reportInfo.totalFollowers,
    },
  ];
};

type CampaignAvatar = { thumbnails?: { tiny?: string } } | null | undefined;

// The campaign adds the creator name and the avatar to the figures, and the details to the errors
type CampaignOverlapError = {
  errorMessage: string;
  username: string;
  avatar?: CampaignAvatar;
};

export const getCampaignAudienceOverlapResults = (
  audienceOverlapData: AudienceOverlapData,
): AudienceOverlapProviderResult[] =>
  Object.keys(SOCIAL_LABELS)
    .filter((provider) => audienceOverlapData[provider])
    .map((provider) => {
      const { audienceOverlap } = audienceOverlapData[provider];
      const errors = (audienceOverlap?.errorsWithCalculatingOverlap ??
        {}) as unknown as Record<string, CampaignOverlapError>;

      return {
        provider,
        reportInfo: audienceOverlap?.reportInfo,
        rows: [
          ...[...(audienceOverlap?.data ?? [])]
            .sort((a, b) => a.username?.localeCompare(b.username))
            .map((creator) => ({
              key: creator.userId ?? creator.username,
              name: creator.username,
              avatarUrl: (creator.avatar as CampaignAvatar)?.thumbnails?.tiny,
              followers: creator.followers,
              uniquePercentage: creator.uniquePercentage,
            })),
          ...Object.entries(errors).map(([username, error]) => ({
            key: `error-${username}`,
            name: error.username,
            avatarUrl: error.avatar?.thumbnails?.tiny,
            errorMessage: error.errorMessage,
          })),
        ],
      };
    });
